import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { LoggingMessageService } from 'src/app/core/services/logging-message.service';
import { PendoService } from 'src/app/core/services/pendo.service';
import { environment } from 'src/environments/environment';
import { StorageService } from 'src/app/core/services/storage.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@Component({
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {
  private selectedSubscriptionID: number;
  private availableSubscriptions: string;

  constructor(
    private pendoService: PendoService,
    private logger: LoggingMessageService,
    private authService: AuthService,
    public sessionService: StorageService) {

    }

    ngOnInit() {      
      //if a home.component is being hit, we need to set the SelectedSubscription to 0
      this.updateSelectedSubscription();
      this.logger.info('home.component', 'ngOnInit', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString , 'fired', '');

      if (environment.EnablePendo) {
        const w: any = window;
        this.pendoService.checkPendo(w, this.authService.SelectedSubscription.toString(), this.authService.AvailableSubscriptionsString);
      }
    }

    private updateSelectedSubscription() {
      const subscriptionId = 0;
      this.authService.SelectedSubscription = subscriptionId;
    }
  
}
